import React, { useEffect, useState } from 'react';
import ContextProviderMenus from '@/components/slide-menu/provide-slide-menu';
import Container from '@/components/container';
import TabNav from '@/components/slide-menu/tab-nav';
import Header from './components/common-header';
import TabContext from './TabContext';
import { Badge } from 'antd';
import './index.less';
import apis from './apis';

const ChannelMicro = (props) => {
  const [isShowTab, setIsShowTab] = useState(true);
  const [checkNum, setCheckNum] = useState(0);

  useEffect(() => {
    apis.channelMicroStatusCount({ type: 3 }).then((res) => {
      const {
        ret,
        data: { approve = '' },
      } = res;
      if (ret === '0') {
        setCheckNum(approve);
      }
    });
  }, []);

  return (
    <>
      <ContextProviderMenus.Provider value={{ children: props.children }}>
        {isShowTab && (
          <>
            <Header />
            <Container margin={{ horizontal: 'max' }}>
              <TabNav
                linkEndWithSearch={false}
                renderTabNavItem={({ title, path }) => {
                  if (checkNum <= 0 || title !== '审核管理') return title;
                  return (
                    <Badge dot className="badge-in-check-channel-micro">
                      {title}
                    </Badge>
                  );
                }}
              />
            </Container>
          </>
        )}
      </ContextProviderMenus.Provider>
      <TabContext.Provider
        value={{
          setTab: (value) => {
            setIsShowTab(value);
          },
          setNum: (value) => {
            setCheckNum(value);
          },
        }}
      >
        <Container margin={{ horizontal: 'max' }}>{props.children}</Container>
      </TabContext.Provider>
    </>
  );
};
export default ChannelMicro;
